import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import './LoginForm.css';
import { FaUser,FaLock } from "react-icons/fa";
import { useEffect } from "react";



const LoginForm = () => {
    const navigate = useNavigate();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');


    useEffect(() => {
          const token = localStorage.getItem("token");
          if (token) navigate("/home", { replace: true });
        }, [navigate]);

    const handleSubmit = async (e) => {
    e.preventDefault();

    try {
  const response = await fetch('https://api.lapegna.xyz/log-in/token', { 
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': 'pastepatate'
    },
    body: JSON.stringify({ username, password })
  });

  console.log('Response:', response);
  console.log('Status:', response.status);

  if (!response.ok) {
    // Se vuoi, puoi mostrare anche il testo di errore dal server
    const errorText = await response.text();
    throw new Error(`Errore HTTP! Status: ${response.status} - ${errorText}`);
  }

  const data = await response.json();
  
  if (data.token) {
    localStorage.setItem('token', data.token);
    setMessage('Login effettuato con successo!');
    navigate("/home", { replace: true });
  } else {
    setMessage('Credenziali non valide');
  }
} catch (error) {
  console.error('Errore:', error);
  setMessage('Si è verificato un problema: ' + error.message);
}

};

    return(
        <div id="loginForm" className='wrapper'>
            <form  onSubmit={handleSubmit}>
                <h1>CED ConTe srl</h1>
                <div className="input-box">
                    <input  type="text" 
                            id="username" 
                            placeholder="utente" 
                            onChange={(e) => setUsername(e.target.value)} 
                            required />
                    <FaUser className='icon'/>
                </div> 
                <div className="input-box">
                    <input  type="password" 
                            id="password" 
                            placeholder="password"  
                            onChange={(e) => setPassword(e.target.value)}
                            required />
                    <FaLock className='icon'/>
                </div> 

                <button type="submit">Accedi</button>
            
            </form>    
            {message && <p>{message}</p>}
            
        </div>

    )
}

export default LoginForm